var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-btn',{staticClass:"scroll-up",attrs:{"color":"primary","fab":""},on:{"click":_vm.scrollUp}},[_c('v-icon',{staticClass:"pa-3",attrs:{"large":""}},[_vm._v("mdi-arrow-up")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }